import { SDKOptions } from "../../types/options";

export type MapProviderNames = "maptiler" | "mapbox" | "google";
export type MapProvider = {
  name: MapProviderNames;
  key?: string;
};

export type Options = {
  lat?: number;
  lng?: number;
  zoom?: number;
  pitch?: number;
  bearing?: number;
  distanceUnit?: "metric" | "imperial";
  marker?: {
    lat: number;
    lng: number;
    icon?: "house" | "pin";
    // Used to show the address over the marker, and for the LC LAT CTA
    addressLabel?: string;
  };
  cooperativeGestures?: boolean;
  mapProvider?: MapProvider;
  hideScores?: boolean;
  collapseScores?: boolean;
};

export type LocalContentProps = SDKOptions<
  Options,
  {
    options: Options | undefined;
  }
>;

export type ScoreCategories =
  | "commute"
  | "amenities"
  | "character"
  | "nature"
  | "wellness"
  | "education";

export enum TrackingPipelineEvents {
  SDK_VIEWED = "LC-Viewed",
  CATEGORY_CLICKED = "LC-Category-Clicked",
  SCORE_CLICKED = "LC-Score-Clicked",
  TRANSPORT_METHOD_CLICKED = "LC-Transportation-Method-Clicked",
  LONG_DESCRIPTION_CLICKED = "LC-Long-Description-Clicked",
  POI_CLICKED = "LC-POI-Clicked",
  COMMUTE_CALCULATOR_CLICKED = "LC-Commute-Comute-Calc-Clicked",
  COMMUTE_CALCULATE_ROUTE = "LC-Commute-Calculate-Route",
  ATTRIBUTION_CLICKED = "LC-Attribution-Clicked",
}

// Why are these named differently?
// https://docs.mixpanel.com/docs/data-structure/events-and-properties#name-events-and-properties-consistently
export enum AnalyticsEvents {
  SDK_VIEWED = "sdk_viewed",
  CATEGORY_SELECTED = "category_selected",
  SCORE_EXPANDED = "score_expanded",
  SCORE_POI_SELECTED = "score_poi_selected",
  POI_CALCULATE_ROUTE = "poi_calculate_route",
  MAP_POI_SELECTED = "map_poi_selected",
  SEARCH_CALCULATE_ROUTE = "search_calculate_route",
}
